export const WITHDRAWAL_SERVICE_LABELS = Object.freeze({
  gom_notifications: "GOM 알림(통합)",
  gom_alarmtalk: "GOM 알림톡",
  gom_sms: "GOM SMS",
  gom_push: "GOM 푸시",
  gom_crm: "GOM CRM 예약",
});

function unwrap(response) {
  return response?.data?.data ?? response?.data ?? {};
}

export function buildWithdrawalListParams(filters) {
  const params = { page: filters.page, limit: filters.limit };
  ["flowVersion", "withdrawalStatus", "serviceStopStatus", "identityCleanupStatus"].forEach(key => {
    if (filters[key]) params[key] = filters[key];
  });
  const searchValue = filters.searchValue?.trim();
  if (searchValue) {
    params.searchType = filters.searchType;
    params.searchValue = searchValue;
  }
  return params;
}

export async function fetchWithdrawalList(client, params) {
  const response = params.searchValue
    ? await client.post("/api/v1/user/admin/withdrawals/search", {
        ...params,
        searchPurpose: "WITHDRAWAL_SUPPORT",
      })
    : await client.get("/api/v1/user/admin/withdrawals", { params });
  const payload = unwrap(response);
  return {
    ...payload,
    items: Array.isArray(payload.items) ? payload.items : [],
    total: Number(payload.total || 0),
  };
}

export async function fetchWithdrawalDetail(client, recordKey) {
  const encoded = encodeURIComponent(recordKey);
  const detailResponse = await client.get(`/api/v1/user/admin/withdrawals/${encoded}`);
  const detail = unwrap(detailResponse);
  if (detail.flowVersion !== "V2") return { detail, attempts: [], alerts: [], events: [] };

  const [attemptResponse, alertResponse, eventResponse] = await Promise.all([
    client.get(`/api/v1/user/admin/withdrawals/${encoded}/attempts`),
    client.get(`/api/v1/user/admin/withdrawals/${encoded}/alerts`),
    client.get(`/api/v1/user/admin/withdrawals/${encoded}/events`),
  ]);
  const attemptPayload = unwrap(attemptResponse);
  const alertPayload = unwrap(alertResponse);
  const eventPayload = unwrap(eventResponse);
  return {
    detail,
    attempts: Array.isArray(attemptPayload.items) ? attemptPayload.items : [],
    alerts: Array.isArray(alertPayload.items) ? alertPayload.items : [],
    events: Array.isArray(eventPayload.items) ? eventPayload.items : [],
  };
}

export function withdrawalServiceLabel(serviceType) {
  return WITHDRAWAL_SERVICE_LABELS[serviceType] || serviceType || "-";
}
